interface UserInfoShape {
  privacyConsents?: string[]
  userGroup?: string
}

interface ConsentOptionShape {
  value: string
  required?: boolean
}

// A consent whose "Campo obbligatorio" toggle is off in the configurator can be left unanswered;
// a required one must be answered and given.
export function validateConsent(option: ConsentOptionShape, value?: string): string | undefined {
  if (!option.required) return undefined
  if (!value) return 'Questo campo è obbligatorio'
  if (value !== 'CONSENT') return 'Questo consenso è obbligatorio'
  return undefined
}

// First login is complete once every consent marked as required in the PSP configuration has been given.
export function needsConsentAcceptance(userInfo: UserInfoShape, consentOptions: ConsentOptionShape[] = []): boolean {
  if (!userInfo.privacyConsents || !userInfo.userGroup) return false
  if (userInfo.userGroup.toUpperCase().includes('CLIENT')) return false
  const privacyConsents = userInfo.privacyConsents
  return consentOptions.some(({value, required}) => required && !privacyConsents.includes(value))
}
